import { ObjectHelpers } from "../helpers/object-helpers";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";

export class TIIndicatorDataToEMACloudSeriesBuilder {
    public static map(rawIndicatorData: TIIndicatorDataModel, indicatorConfig: any): Array<any> {
        if (!indicatorConfig || !indicatorConfig.series || !rawIndicatorData?.childIndicators?.length) {
            return [];
        }

        const series1 = ObjectHelpers.copy(indicatorConfig.series[0]);
        series1.yAxis = rawIndicatorData.name + '-ind-y-axis';
        series1.name = rawIndicatorData.getClassName() + series1.name;
        series1.className = rawIndicatorData.getClassName() + series1.className;
        return [series1];
    }
}